module.exports = __webpack_public_path__ + "img/sign_get_1.2b62f9c3.png";